"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.define = void 0;
/**
 * Defines the routes and returns scoped `receive` and `resolve` functions that
 * access the given routes.
 */
function define(routes) {
  /**
   * Returns the route defintion by a given name.
   *
   * @throws {Error} when given name is not found in routes.
   */
  var receive = function (name) {
    var route = routes[name];
    if (!route) {
      throw new Error("Can not find route by name \"".concat(name, "\"."));
    }
    return route;
  };
  /**
   * This builds a path for a route by name and params. Params are dynamic parts
   * of a single path, that are defined in the format: `[param]`. Optional params
   * are defined by a question mark at the end like: `[optionalParam?]`. The
   * params need to be passed as a key/value object. Optional params are not
   * required to be defined in this object, but missing params will throw an
   * error.
   *
   * @throws {Error} when given name is not found in routes.
   * @throws {Error} when given params are not matching the route definition.
   */
  var resolve = function (name, params) {
    if (params === void 0) {
      params = {};
    }
    var REGEXP_PARAMS = /\[([a-zA-Z]*)(\??)\]/g;
    var REGEXP_SLASH_SANITIZED = /\/(\/*)/g;
    var REGEXP_SLASH_ENDOFPATH = /\/$/;
    var parameters = __assign({}, params);
    var route = receive(name);
    var match = null;
    var path = route;
    // This mimics a .matchAll() which is not implemented in all all node and
    // browser versions.
    while ((match = REGEXP_PARAMS.exec(route)) !== null) {
      var key = match[1],
        optional = match[2];
      var replace = "".concat(parameters[key]);
      if (!parameters[key]) {
        if (!optional) {
          throw new Error("Missing param \"".concat(key, "\" for route \"").concat(name, "\"."));
        }
        replace = '';
      }
      path = path.replace("[".concat(key).concat(optional, "]"), replace);
    }
    path = path.replace(REGEXP_SLASH_SANITIZED, '/');
    if (REGEXP_SLASH_ENDOFPATH.test(path) && !REGEXP_SLASH_ENDOFPATH.test(route)) {
      path = path.replace(REGEXP_SLASH_ENDOFPATH, '');
    }
    // This case will never apply based on the definition format of a path...
    // if (!REGEXP_SLASH_ENDOFPATH.test(path) && REGEXP_SLASH_ENDOFPATH.test(route)) {
    // 	path = `${path}/`;
    // }
    return path;
  };
  return {
    receive: receive,
    resolve: resolve
  };
}
exports.define = define;